import { __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import ReportsServices from '@/modules/reports/ReportsServices';
var sale = {
  table: '',
  credit_card: '',
  created_at: '',
  price: '',
  payment_type: ''
};

var SaleModel =
/** @class */
function (_super) {
  __extends(SaleModel, _super);

  function SaleModel() {
    var _this = _super.call(this, sale, ReportsServices) || this;

    _this.modelName = 'Venta';
    _this.request = 'JSON';
    return _this;
  }

  SaleModel.prototype.requestsHistoriesReport = function (protocol) {
    return __awaiter(this, void 0, Promise, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.requestsHistoriesReport({
              method: 'POST',
              query: protocol
            })];

          case 1:
            response = _a.sent();

            if (response && response.data) {
              return [2
              /*return*/
              , {
                data: response.data.results,
                total: response.data.total,
                sum: response.data.sum
              }];
            }

            return [2
            /*return*/
            , {
              data: [],
              total: 0,
              sum: 0
            }];
        }
      });
    });
  };

  SaleModel.prototype.salesReport = function (protocol) {
    return __awaiter(this, void 0, Promise, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.salesReport({
              method: 'POST',
              query: protocol
            })];

          case 1:
            response = _a.sent();

            if (response && response.data) {
              return [2
              /*return*/
              , {
                data: response.data.results,
                total: response.data.total,
                sum: response.data.sum
              }];
            }

            return [2
            /*return*/
            , {
              data: [],
              total: 0,
              sum: 0
            }];
        }
      });
    });
  };

  SaleModel.prototype.getSaleFile = function (protocol) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.downloadSalesFile({
              method: 'GET',
              query: protocol,
              headers: {
                Accept: '*/*'
              },
              responseType: 'blob'
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  SaleModel.prototype.getHistoryFile = function (protocol) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.downloadHistoryFile({
              method: 'GET',
              query: protocol,
              headers: {
                Accept: '*/*'
              },
              responseType: 'blob'
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  return SaleModel;
}(BaseModel);

export default SaleModel;